<template>
<div class="chapter">
<div class="inner_page">
<div class="prelims-page" id="d57691ac4acf6-d1e445"><span id="pagev">
<p class="dedication-first"><em class="italic ">For Carol Chase</em></p>
<p class="dedication"><em class="italic ">A good friend knows all your stories; a best friend helps you write them</em>.</p></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781780106519_epub_ded.vue?40de9e18